import LoginStore from './LoginStore'
import CustomersStore from './CustomersStore'
import ProjectsStore from './ProjectsStore'
import UsersStore from './UsersStore'
import SpacesStore from './SpacesStore'
import TasksStore from './TasksStore'
import TeamsStore from './TeamsStore'
import EquipmentsStore from './EquipmentsStore'
import ActionItemsStore from './ActionItemsStore'
import BudgetStore from './BudgetStore'
import ProjectBudgetStore from './ProjectBudgetStore'
import TagStore from './TagStore'
import ProjectBudgetWidgetStore from './ProjectBudgetWidgetStore'
import HomeBudgetStore from './HomeBudgetStore'
import StaticItemsStore from './StaticItemsStore'
import CommentsStore from './CommentsStore'
import SpaceTemplatesStore from './SpaceTemplatesStore'
import TaskTemplateStore from './TaskTemplatesStore'
import PermissionsStore from './PermissionsStore'
import RolesStore from './RolesStore'
import TaskGroupStore from './TaskGroupStore'
import ReportingStore from './ReportingStore'
import GalleryStore from './GalleryStore'
import NotificationsStore from './NotificationsStore'
import HomeStore from './HomeStore'
import ReportBudgetStore from './ReportBudgetStore'
import ResellerStore from './ResellerStore'
import RevenueStore from './RevenueStore'
import ResellerHomeStore from './ResellerHomeStore'
import FaqStore from './FaqStore'
import NotesStore from './NotesStore'
import OrganizationStore from './OrganizationStore'
import OrgAllUsersStore from './OrgAllUsersStore'
import SubscriptionStore from './SubscriptionStore'
import history from '../history'
import { routes } from '../routes'
import JobBoardStore from './JobBoardStore'

class CombinedStore {
  constructor() {
    this.loginStore = new LoginStore()
    this.customersStore = new CustomersStore()
    this.projectsStore = new ProjectsStore()
    this.usersStore = new UsersStore()
    this.spacesStore = new SpacesStore()
    this.tasksStore = new TasksStore()
    this.teamsStore = new TeamsStore()
    this.equipmentsStore = new EquipmentsStore()
    this.actionItemsStore = new ActionItemsStore()
    this.BudgetStore = new BudgetStore()
    this.ProjectBudgetStore = new ProjectBudgetStore()
    this.TagStore = new TagStore()
    this.ProjectBudgetWidgetStore = new ProjectBudgetWidgetStore()
    this.HomeBudgetStore = new HomeBudgetStore()
    this.staticItemsStore = new StaticItemsStore()
    this.commentsStore = new CommentsStore()
    this.spaceTemplatesStore = new SpaceTemplatesStore()
    this.taskTemplatesStore = new TaskTemplateStore()
    this.permissionStore = new PermissionsStore()
    this.rolesStore = new RolesStore()
    this.taskGroupStore = new TaskGroupStore()
    this.reportingStore = new ReportingStore()
    this.galleryStore = new GalleryStore()
    this.notificationsStore = new NotificationsStore()
    this.homeStore = new HomeStore()
    this.ReportBudgetStore = new ReportBudgetStore()
    this.ResellerStore = new ResellerStore()
    this.RevenueStore = new RevenueStore()
    this.ResellerHomeStore = new ResellerHomeStore()
    this.faqStore = new FaqStore()
    this.notesStore = new NotesStore()
    this.organizationStore = new OrganizationStore()
    this.orgAllUsersStore = new OrgAllUsersStore()
    this.subscriptionStore = new SubscriptionStore()
    this.jobBoardStore = new JobBoardStore()
  }

  navigate = () => {
    history.replace(routes.login.generateRoute())
  }

  navigateOrg = () => {
    history.replace(routes.assignorg.generateRoute())
  }

  resetStore = () => {
    let _ = this.customersStore?.resetStore?.()
    _ = this.projectsStore?.resetStore?.()
    _ = this.usersStore?.resetStore?.()
    _ = this.spacesStore?.resetStore?.()
    _ = this.tasksStore?.resetStore?.()
    _ = this.teamsStore?.resetStore?.()
    _ = this.equipmentsStore?.resetStore?.()
    _ = this.actionItemsStore?.resetStore?.()

    _ = this.commentsStore?.resetStore?.()
    _ = this.spaceTemplatesStore?.resetStore?.()
    _ = this.taskTemplatesStore?.resetStore?.()

    _ = this.rolesStore?.resetStore?.()
    _ = this.taskGroupStore?.resetStore?.()
    _ = this.reportingStore?.resetStore?.()
    _ = this.galleryStore?.resetStore?.()
    _ = this.notificationsStore?.resetStore?.()
    _ = this.homeStore?.resetStore?.()
    _ = this.permissionStore?.resetPermissions()
    _ = this.faqStore?.resetStore()
    _ = this.notesStore?.resetStore()
    _ = this.organizationStore?.resetStore?.()
    _ = this.subscriptionStore?.resetStore?.()
    _ = this.orgAllUsersStore?.resetStore?.()
    _ = this.jobBoardStore?.resetStore?.()
  }
}

export default new CombinedStore()
